/**
 * @generated SignedSource<<30e72300f9d66446fbb2f0a4d69d1278>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type JoinCompanyInput = {
  email: string;
  join?: boolean | null;
  clientMutationId?: string | null;
};
export type joinCompanyMutation$variables = {
  input: JoinCompanyInput;
};
export type joinCompanyMutation$data = {
  readonly joinCompany: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly person: {
      readonly node: {
        readonly id: string;
      } | null;
    } | null;
  } | null;
};
export type joinCompanyMutation = {
  variables: joinCompanyMutation$variables;
  response: joinCompanyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "JoinCompanyPayload",
    "kind": "LinkedField",
    "name": "joinCompany",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PersonTypeEdge",
        "kind": "LinkedField",
        "name": "person",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Person",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "joinCompanyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "joinCompanyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b742c9d46f70a83c3b01e840f05b8b1a",
    "id": null,
    "metadata": {},
    "name": "joinCompanyMutation",
    "operationKind": "mutation",
    "text": "mutation joinCompanyMutation(\n  $input: JoinCompanyInput!\n) {\n  joinCompany(input: $input) {\n    errors\n    person {\n      node {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9447723403369ab0e169fd661aa42b63";

export default node;
